import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export const InfoRow = ({
  icon,
  children,
  className,
}: {
  icon: ReactNode;
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn('flex items-center gap-2', className)}>
    <div className="shrink-0 flex items-center justify-center mt-0.5 text-muted-foreground fill-muted-foreground [&>svg]:size-6">
      {icon}
    </div>
    <div className="flex-1 min-w-0 wrap-break-word text-popover-foreground">{children}</div>
  </div>
);
